import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";

import NavBreadcrumb from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import TableMeasuresManager from "./measures/TableMeasuresManager";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "../utils/buttonsActions";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import MeasureFiltersManager from "./measures/MeasureFiltersManager";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import { PagerModel } from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";

const buttonsActions = new ButtonsActions();

const ViewMeasures = () => {
    const { t } = useTranslation("routes");
    const [itemsShown, setItemsShown] = useState([]);
    const [filterParams, setFilterParams] = useState({
        groups: [],
        device_groups: [],
        zones: [],
        routes: [],
        islands: [],
    });
    const [currentFilters, setCurrentFilters] = useState({});
    const title = t("labels.measures");

    const bread = [
        { name: t("labels.history"), url: "/historic/", current: false },
        { name: title, current: true },
    ];

    const [buttonsTB, setButtonsTB] = useState(buttonsActions);

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const [isLoading, setIsLoading] = useState(false);
    const pagerModelRef = useRef(new PagerModel());

    useEffect(() => {
        document.title = title;
        const buttons = { ...buttonsActions };
        buttons.title = title;
        setButtonsTB(buttons);
        pagerModelRef.current.handleCallApi = () => fetchPostMeasures();
        filters.current.filter = (e) => {
            pagerModelRef.current.paging.page = 1;
            setCurrentFilters({ ...filters.current.chosen });
            fetchPostMeasures();
        };
        // borrar filtros guardados
        sessionStorage.removeItem("viewsHistoricFilters");

        const fetchGetMeasures = async () => {
            setIsLoading(true);
            const resp = await axiApi.get(`/api/assets/`);
            if (resp.data) {
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                pagerModelRef.current.active = resp.data.items.length > 0;
                pagerModelRef.current.paging.setPager(resp.data);
                setFilterParams({
                    groups: resp.data.params.groups || [],
                    device_groups: resp.data.params.device_groups || [],
                    zones: resp.data.params.zones || [],
                    routes: resp.data.params.routes || [],
                    islands: resp.data.params.islands || [],
                });
            }
            setIsLoading(false);
        };
        fetchGetMeasures();
    }, []);

    const fetchPostMeasures = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post(`/api/assets/`, filters.current.chosen, {
                params: pagerModelRef.current.paging.getParams(),
            });
            if (resp.data) {
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                pagerModelRef.current.active = resp.data.items.length > 0;
                pagerModelRef.current.paging.setPager(resp.data);
                sessionStorage.setItem("viewsHistoricFilters", JSON.stringify(filters.current.chosen));
            }
        } catch (error) {
            console.error("Error fetching measures:", error);
            setItemsShown([]);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            <NavBreadcrumb bread={bread} navs={navs} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <MeasureFiltersManager filters={filters} params={filterParams} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" />
            <LoaderSpinner isLoading={isLoading}>
                <TableMeasuresManager
                    items={items.current.showed}
                    itemsShown={itemsShown}
                    setButtonsTB={setButtonsTB}
                    activeFilters={currentFilters}
                />
            </LoaderSpinner>
        </>
    );
};

export default ViewMeasures;
